'use strict';
import React, { Component } from 'react';
import ModalMensaje from '../../../Common/Components/ModalMensaje';

class IntegracionPantallas extends Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        const body = document.body;
        body.style.overflow = '';
    }

    componentDidMount() {
        this.props.cargaInicialPantalla(this.props.data.login);

        const body = document.body;
        const iframe = body.querySelector('.integracionPantallas__contenedor__iframe iframe');

        if (iframe && body.children.length === 1) {
            body.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
        }
    }

    render() {
        const {
            modalMensaje,
            mostrarModal,
            ruta,
            token,
            urlSitio
        } = this.props.data;

        if (!token) {
            return null;
        }

        let urlCompleta = ruta;//ruta.includes('?') ? ruta + "&token=" + token : ruta + "?token=" + token;

        return (
            <div>
                <div className="integracionPantallas__contenedor__iframe">
                    <iframe src={urlCompleta}></iframe>
                </div>

                {mostrarModal ?
                    <ModalMensaje
                        mensaje={modalMensaje}
                        titulo={"Integración Pantallas"}

                        mostrarOcultarModal={this.props.mostrarOcultarModal}
                    />
                :
                    null
                }
            </div>
        );
    }
}

export default IntegracionPantallas;
